import PropTypes from 'prop-types';
import React from 'react';
import styles from './Header.scss';

const RefinementContentContainer = ({ children, onClick, ariaLabel, className }) => (
  <div className={[styles.container, className].join(' ')} onClick={onClick} role="button" tabIndex="0" aria-label={ariaLabel}>
    {children}
  </div>
);

RefinementContentContainer.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default RefinementContentContainer;
